import { render, staticRenderFns } from "./ViewCandidateStatus.vue?vue&type=template&id=5d22d0bd&scoped=true&"
import script from "./ViewCandidateStatus.vue?vue&type=script&lang=js&"
export * from "./ViewCandidateStatus.vue?vue&type=script&lang=js&"
import style0 from "./ViewCandidateStatus.vue?vue&type=style&index=0&id=5d22d0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22d0bd",
  null
  
)

export default component.exports